export function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative pt-32 pb-20 min-h-screen flex items-center"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/7e0093ef1b726e9f923611ddfe9cb420.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-gray-900/85 to-transparent"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 w-full">
        <div className="max-w-2xl">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Secure Your Digital Life with <strong>TRAMETAL VPN</strong>
          </h2>
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            Experience ultimate online privacy and security with our advanced <strong>VPN solution</strong>. Browse anonymously, access global content, and protect your data with military-grade encryption from <strong>TRAMETAL S.A.S</strong>.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button 
              onClick={scrollToContact}
              className="bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-teal-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Get Started Now
            </button>
            <button 
              onClick={() => {
                const element = document.getElementById('features');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap cursor-pointer"
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}